import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
const initialState = {
  products: [],
  selectionChanged: false,
  rowData4: [],
  rowData3: [],
  rowData: [],
  rowData2: [],
  idpatient: "",
  nom: "",
  prenom: "",
  civilite: "",
  nom_mutuelle: "",
  fk_id_liste_mutuelle: "",
  fk_id_civilite: "",
  cin: "",
  date_naissance: "",
  commentaire_sur_patient: "",
  tel: "",
  tel2: "",
  tel3: "",
  id_create_user: "",
  cinSearch: "",
  date_naissanceSearch: "",
  nomSearch: "",
  prenomSearch: "",
  telSearch: "",
  date_consultation: "",
  fk_id_patient1: "",
  fk_id_acte: "",
  PathName: "",
  age: "",
  couleur: "",
  created_at: "",
  done: "",
  nom_acte: "",
  rest: "",
  sum_act: "",
  bloc: "",
  didnt_come: "",
  pathologie_principale: "",
  allergie_connue: "",
  DATE_NAISSANCE_SERVER: "",
  AGEPATIENT: "",
  id_Magica: "",
  globalchoseDate: moment().format("YYYY-MM-DD"),
  fk_id_medecin: "",
  fk_id_medecinSelect: 3,
  user_name: ""
};

export const PatientelleSlice = createSlice({
  name: "PatientelleGrid",
  initialState,
  reducers: {
    Globalfk_id_medecinSelect: (state, action) => {
      state.fk_id_medecinSelect = action.payload;
    },
    GlobalDATEPatientelle: (state, action) => {
      state.globalchoseDate = action.payload;
    },
    fetch_products: (state, action) => {
      state.products = action.payload;
    },
    fetch_success3: (state, action) => {
      state.rowData3 = action.payload;
    },
    fetch_success4: (state, action) => {
      state.rowData4 = action.payload;
    },
    fetch_success: (state, action) => {

      const newArr = action?.payload?.map(obj => {
        if (obj.nom_acte.indexOf("-") === 1) {
          return { ...obj, nom_acte: obj.nom_acte.slice(3) };
        }

        return obj;
      });

      state.rowData = newArr;
    },
    fetch_success_DUO: (state, action) => {
      state.rowData2 = action.payload;
    },
    form_load: (state, action) => {
      state.idpatient = action.payload.idpatient;
      state.nom = action.payload.nom;
      state.prenom = action.payload.prenom;
      state.civilite = action.payload.civilite;
      state.nom_mutuelle = action.payload.nom_mutuelle;
      state.fk_id_liste_mutuelle = action.payload.fk_id_liste_mutuelle;
      state.fk_id_civilite = action.payload.fk_id_civilite;
      state.cin = action.payload.cin;
      state.date_naissance = action.payload.date_naissance;
      state.commentaire_sur_patient = action.payload.commentaire_sur_patient;
      state.tel = action.payload.tel;
      state.tel2 = action.payload.tel2;
      state.tel3 = action.payload.tel3;
      state.pathname = action.payload.pathname;
      state.pathologie_principale = action.payload.pathologie_principale;
      state.allergie_connue = action.payload.allergie_connue;
      state.AGEPATIENT = action.payload.AGEPATIENT;
      state.id_Magica = action.payload.id_Magica;
      state.DATE_NAISSANCE_SERVER = action.payload.DATE_NAISSANCE_SERVER;
      state.fk_id_medecin = action.payload.fk_id_medecin;
      state.user_name = action.payload.user_name;
    },
    post_success_grab_ID: (state, action) => {
      state.id_create_user = action.payload;
    },
    PathName_graber: (state, action) => {
      state.PathName = action.payload;
    },
    previous_search: (state, action) => {
      state.cinSearch = action.payload.cin;
      state.date_naissanceSearch = action.payload.date_naissance;
      state.nomSearch = action.payload.nom;
      state.prenomSearch = action.payload.prenom;
      state.telSearch = action.payload.tel;
    },
    act_form_load: (state, action) => {
      state.age = action.payload.age;
      state.nom = action.payload.nom;
      state.prenom = action.payload.prenom;
      state.couleur = action.payload.couleur;
      state.created_at = action.payload.created_at;
      state.date_consultation = action.payload.date_consultation;
      state.date_naissance = action.payload.date_naissance;
      state.done = action.payload.done;
      state.fk_id_acte = action.payload.fk_id_acte;
      state.fk_id_patient1 = action.payload.fk_id_patient1;
      state.idpatient = action.payload.fk_id_patient1;
      state.nom_acte = action.payload.nom_acte;
      state.rest = action.payload.rest;
      state.sum_act = action.payload.sum_act;
      state.bloc = action.payload.bloc;
      state.didnt_come = action.payload.didnt_come;
      state.id_Magica = action.payload.id_Magica;
      state.fk_id_medecin = action.payload.fk_id_medecin;
      state.user_name = action.payload.user_name;
    },
  },
});

export const {
  GlobalDATEPatientelle,
  fetch_products,
  act_form_load,
  fetch_success,
  fetch_success3,
  fetch_success4,
  form_load,
  post_success_grab_ID,
  previous_search,
  PathName_graber,
  fetch_success_DUO,
  Globalfk_id_medecinSelect
} = PatientelleSlice.actions;

export const selectPatientelleGrid = (state) => state.PatientelleGrid;

export default PatientelleSlice.reducer;
